const DEVICE_ID_KEY = 'erpz_device_id';
/** Mismo formato que acepta el backend en X-Device-Id. */
const VALID_ID = /^[A-Za-z0-9._-]{1,64}$/;

function newId() {
    const cryptoApi = typeof globalThis !== 'undefined' ? globalThis.crypto : undefined;
    if (cryptoApi?.randomUUID) return cryptoApi.randomUUID();
    if (cryptoApi?.getRandomValues) {
        return Array.from(cryptoApi.getRandomValues(new Uint8Array(16)), (b) => b.toString(16).padStart(2, '0')).join('');
    }
    return `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 14)}`;
}

/**
 * Id aleatorio y estable de este navegador (no identifica a la persona):
 * agrupa las fallas de un mismo equipo. Si el almacenamiento falla devuelve
 * uno temporal; nunca lanza.
 */
export function getOrCreateDeviceId(storage) {
    try {
        const stored = storage?.getItem(DEVICE_ID_KEY);
        if (stored && VALID_ID.test(stored)) return stored;
    } catch { /* Se genera uno nuevo. */ }

    const id = newId();
    try {
        storage?.setItem(DEVICE_ID_KEY, id);
    } catch { /* Sin persistencia: este id solo vale para la sesión actual. */ }
    return id;
}
